import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("admin@yourstore.com");
  const [password, setPassword] = useState("admin");

  const navigate = useNavigate ()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 md:px-8">
      {/* Title */}
      <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
        Admin area demo
      </h1>
      <hr className="border-gray-300 w-full max-w-5xl my-4" />

      {/* Login Box */}
      <div className="bg-gray-100 w-full max-w-2xl shadow-sm rounded-md p-6 md:p-10">
        <h2 className="text-lg md:text-xl font-semibold text-center text-gray-800 mb-6">
          Welcome, please sign in!
        </h2>

        {/* Form */}
        <form className="space-y-5">
          {/* Email */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3">
            <label className="w-28 text-gray-700 font-medium text-right">
              Email:
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 border border-gray-400 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400"
              placeholder="admin@yourstore.com"
            />
          </div>

          {/* Password */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-3">
            <label className="w-28 text-gray-700 font-medium text-right">
              Password:
            </label>
            <div className="relative flex-1">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-400 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400"
                placeholder="•••••"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-2.5 text-gray-600"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Remember Me */}
          <div className="flex justify-center items-center gap-2">
            <input type="checkbox" className="w-4 h-4" />
            <label className="text-gray-700 text-sm">Remember me?</label>
          </div>

          {/* Login Button */}
          <div className="flex justify-center">
            <button onClick={()=> navigate ("/dashboard")}
              type="submit"
              className="bg-sky-900 hover:bg-sky-900 text-white px-10 py-2 rounded transition-all font-medium">
              LOG IN
            </button>
          </div>
        </form>
      </div>

      {/* Default Info */}
      <div className="text-center mt-10">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          Defaults for admin area
        </h3>
        <hr className="border-gray-300 w-full max-w-5xl mb-4" />
        <p className="text-gray-700">
          Admin email: <span className="font-medium">admin@yourstore.com</span>
        </p>
        <p className="text-gray-700">
          Admin password: <span className="font-medium">admin</span>
        </p>
      </div>
    </div>
  );
}
